import Layout2 from '@/layout/Layout2'
import LayoutBlank from '@/layout/LayoutBlank'

export default [{
  path: '/merchant_admin',
  component: LayoutBlank,
  children: [{
    path: '',
    name: "merchant_admin",
    component: () => import('@/merchanAdmin/login/AuthenticationLoginV1'),
  }]
}]
